<template>
  <div class="main">
    <div class="banner">
      <h3 class="banner-title">慢病管理解决方案</h3>
      <p class="banner-desc">帮助慢病顾客改善服药依从性，改善生活型态，改善疗效，减少并发症；提升会员粘度和光顾频次；提升药房专业服务力，塑造药房专业形象</p>
      <router-link class="banner-btn" to="/try">申请使用</router-link>
    </div>

    <div class="about">
      <div class="about-container w">
        <div class="m-title">
          <h2>公司介绍</h2>
          <p>COMPANY INTRODUCTION</p>
        </div>
        <div class="about-list">
          <p>深圳厚科云健康科技有限公司成立于2015年8月，专注于健康管理、慢病管理系统化解决方案。以药房、医药工业企业、医药电商为主要目标客户，为客户在专业化服务方面提供完整的解决方案，帮助企业提升专业服务力，建立差异化的竞争优势。</p>
          <p>公司主要成员曾接受美国大型连锁药房核心经营管理技术，药房专业服务的系统培训，并担任国内知名连锁医药企业信息化核心技术研发及管理工作，拥有十多年医药行业信息化管理经验，公司通过资深的医药行业经验、先进的管理理念，开发出针对药房管理的专业健康管理云平台，系统秉承简简洁实用的原则，充分融合药房管理在专业健康照顾、慢病管理、绩效考核等管理理念，在行业内处于领先优势。</p>
          <p>
            针对药房、诊所及社康中心提供健康管理、慢病管理系统化解决方案，帮助连锁药房建立慢病管理体系与流程，提供系统上线辅导与培训，指导慢病管理落地实施，提升慢病会员的满意度和品牌忠诚度，提升慢病品类以及关联品类的销售业绩。
            与医药工业企业合作，通过与零售药店合作实施慢病管理，争取最大程度利用终端资源，提升品牌影响力与与销售业绩。
          </p>
          <p>公司将一如既往地以提供优质服务、科技创新的经营管理理念，不断为客户带来价值，为员工实现价值，为合作伙伴创造价值而努力。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {}
};
</script>>
<style lang='scss' scoped>
.banner {
  width: 100%;
  height: 393px;
  background: #f29b33 url("../../assets/imgs/banner_bg.png") no-repeat top
    center / 100%;
  padding: 85px 0;
  .banner-title {
    font-size: 32px;
    color: #fff;
    line-height: 45px;
    text-align: center;
    font-weight: 400;
  }
  .banner-desc {
    width: 650px;
    margin: 24px auto 34px;
    font-size: 20px;
    color: #fff;
    line-height: 35px;
  }
  .banner-btn {
    display: block;
    margin: 0 auto;
    width: 96px;
    height: 32px;
    background: #fff;
    border-radius: 2px;
    color: #f08300;
    font-size: 16px;
    text-align: center;
    line-height: 32px;
  }
}

.about {
  padding: 88px 0 64px;
  .m-title {
    margin-bottom: 48px;
  }
  .about-container {
    .about-list {
      width: 1040px;
      margin: 0 auto;
      p {
        font-size: 18px;
        font-weight: 400;
        color: #818181;
        line-height: 25px;
        &:not(:last-child) {
          margin-bottom: 32px;
        }
      }
    }
  }
}
</style>
